import { render, staticRenderFns } from "./SharePhoto.vue?vue&type=template&id=23304487&lang=pug&"
import script from "./SharePhoto.vue?vue&type=script&lang=js&"
export * from "./SharePhoto.vue?vue&type=script&lang=js&"
import style0 from "./SharePhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports